import React, { useState } from "react";
import "../../styles/containers/Basket.scss";
import PaperBasket from "../../components/PaperBasket";
import { Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  addOrderToBasket,
  confirmOrderPost,
  confirmOrders,
  getOrders,
  removeOrders,
  getOrdersFromBasket,
  removeOrderPost,
} from "../../store/actions/partsActions";
import Loader from "../../components/Loader";
import Button from "../../components/Button";
import { Storage } from "aws-amplify";
function Basket() {
  const users = useSelector((state) => state.users);
  const parts = useSelector((state) => state.parts);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [delLoading, setDelLoading] = useState(false);

  const { getOrderFromBasket, addOrder, confirmOrder, removeOrder } = parts;
  const { getUser } = users;
  let [basket, setBasket] = useState([]);
  let [allIds, setAllIds] = useState([]);
  useEffect(() => {
    dispatch(confirmOrderPost());
    dispatch(addOrderToBasket());
  }, []);
  useEffect(() => {
    if (getUser?.user?.park_id) {
      setButtonLoading(false);
      setOrderLoading(false);
      setQuoteLoading(false);
      const data = {
        park_id: parseInt(getUser?.user?.park_id),
      };
      dispatch(getOrders(data));
    }
  }, [getUser?.user?.park_id]);

  useEffect(() => {
    if (addOrder?.isPost && addOrder?.success) {
      setButtonLoading(false);
      setOrderLoading(false);
      setQuoteLoading(false);
      const data = {
        park_id: parseInt(getUser?.user?.park_id),
      };
      dispatch(getOrders(data));
    }
  }, [addOrder?.success]);

  const RequestOperation = (operation) => {
    setButtonLoading(true);
    if (operation === "Request For Quote") {
      setQuoteLoading(true);
    }
    if (operation === "Ordered") {
      setOrderLoading(true);
    }
    let data = {
      park_id: getUser?.user?.park_id,
      order_ids: allIds,
      operation: operation,
      order_by: `${getUser?.user?.first_name} ${getUser?.user?.last_name}`,
    };

    dispatch(confirmOrders(data));
  };
  let handleDelete = (id, index) => {
    setDelLoading(true);
    let data = {
      park_id: parseInt(getUser?.user?.park_id),
      order_id: id,
    };
    dispatch(removeOrders(data, index));
  };

  useEffect(() => {
    if (confirmOrder?.success) {
      setButtonLoading(false);
      setOrderLoading(false);
      setQuoteLoading(false);
      setBasket([]);
      toast.success(`Operation Successful! ${confirmOrder?.message}`);
    } else if (confirmOrder?.error) {
      setButtonLoading(false);
      setOrderLoading(false);
      setQuoteLoading(false);
      toast.error(`Operation Failed! ${confirmOrder?.error}`);
    }
  }, [confirmOrder?.isPost]);
  useEffect(() => {
    if (
      (getOrderFromBasket?.isFetched && getOrderFromBasket?.success) ||
      getOrderFromBasket?.orders.length
    ) {
      setBasket([]);
      setDelLoading(false);
      let idArray = [];
      getOrderFromBasket?.orders?.forEach((orderFromBasket) => {
        const {
          description,
          image_url,
          order_by,
          quantity,
          id,
        } = orderFromBasket;
        idArray.push(parseInt(id));
        Storage.get(image_url[0]).then((res) => {
          const data = {
            description,
            image_url: `${res}`,
            order_by,
            quantity,
            id,
          };
          setBasket((prevBasketArr) => [...prevBasketArr, data]);
        });
      });
      setAllIds(idArray);

      setLoading(false);

      dispatch(addOrderToBasket());
    }
  }, [
    getOrderFromBasket?.isFetched,
    addOrder?.success,
    confirmOrder?.success,
    getOrderFromBasket?.orders,
  ]);

  useEffect(() => {
    if (removeOrder?.isPost && removeOrder?.success) {
      toast.success(`${removeOrder.message}`, {
        autoClose: 2000,
      });
      dispatch(removeOrderPost());
      setBasket([]);
      setLoading(false);
    } else if (removeOrder?.isPost && removeOrder?.error) {
      toast.error(`${removeOrder.error}`);
      setLoading(false);
    }
  }, [removeOrder?.isPost]);
  return (
    <div className="Basket">
      <h1>Basket</h1>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {basket.length ? (
            <>
              {basket.map(
                ({ description, image_url, quantity, id, order_by }, index) => {
                  return (
                    <PaperBasket
                      desc={description}
                      image={image_url}
                      quantity={quantity}
                      index={index}
                      key={index}
                      Basket={true}
                      id={id}
                      handleDelete={handleDelete}
                      delLoading={delLoading}
                    />
                  );
                }
              )}
              <Button
                className={`btn blue`}
                onClick={() => RequestOperation("Request For Quote")}
                disabled={buttonLoading}
                basket={true}
                title={"Request Quotation"}
                loader={quoteLoading}
              ></Button>
              <Button
                className="btn red"
                onClick={() => RequestOperation("Ordered")}
                title={"Direct Order"}
                basket={true}
                disabled={buttonLoading}
                loader={orderLoading}
              ></Button>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <Typography variant="h6">No Orders to Show</Typography>
            </div>
          )}
        </>
      )}
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

export default Basket;
